import { render } from "./BreadcrumbLinkIsHome.vue?vue&type=template&id=2fa51d6e"
import script from "./BreadcrumbLinkIsHome.vue?vue&type=script&lang=js"
export * from "./BreadcrumbLinkIsHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__